import { replace } from 'connected-react-router';
import { put, take } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import { PERSONAL_DATA_MODAL_PARAM_KEY } from 'app/widgets/PersonalDataModal';

import { OPEN_USERNAME_MODAL } from '../actions';

export default function* displayModalSaga(): SagaIterator {
  while (true) {
    const action = yield take([
      OPEN_USERNAME_MODAL,
    ]);
    switch (action.type) {
      case OPEN_USERNAME_MODAL:
        yield put(replace({ search: PERSONAL_DATA_MODAL_PARAM_KEY }));
        break;
    }
  }
}
